import { FunctionComponent } from 'react';
import { Outlet } from 'react-router';

export const PublicLayout: FunctionComponent = () => {
  return (
    <div className="h-full w-full space-y-9">
      <div className="h-full w-full">
        <Outlet />
      </div>
    </div>
  );
};
